export var highlight = {
    backgroundColor: '#ffc400',
    color: '#222',
};
